// components/Membres.js
import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { MdDeleteForever } from "react-icons/md";
import ImageViewer from 'react-simple-image-viewer';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import VideoThumbnail from './VideoThumbnail';
import { LazyLoadImage } from 'react-lazy-load-image-component';



function ImageTileComponent(props) {
  const [data, setData] = useState(props.data);


  //Modal
  const [show, setShow] = useState(false);
  const [enableError, setEnableError] = useState(false);

  const handleClose = () => {
    setShow(false)
    setActiveFilename("")
  };

  const handleConfirm = async () => {
    try {
      const response = await axios.delete(`/api/defisuploads/${activeFilename}`);
      if (response.status === 200) {
        //console.log(response.data);
        //console.log('File deleted successfully');
        setData((prevImages) => prevImages.filter((image) => image.filename !== activeFilename));
        setShow(false)
      }
    } catch (error) {
      handleError(error);
    }

  };

  const handleError = (error) => {
    setErrorMessage(error)
    setEnableError(true)
  };

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [activeFilename, setActiveFilename] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [playingVideo, setPlayingVideo] = useState(null);

  const handleThumbnailClick = (filename) => {
    setPlayingVideo(filename);
  };


  const openImageViewer = useCallback((filename, index) => {
    setImages([filename])
    setCurrentImage(0);
    //setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const handleClick = (filename, index) => {
    //alert("Delte file" + filename);
    setShow(true);
    setActiveFilename(filename);
  };

  // useEffect(() => {
  //   axios.get('http://localhost:3000/api/membres')
  //     .then(response => {
  //       setMembres(response.data);
  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  // }, []);

  return (
    <div style={styles.gallery}>
      {data.map((uploadFile, index) => {
        console.log(props)
        if (
          ["image/jpeg", "image/png", "image/gif", "image/webp", "image/svg+xml", "image/bmp", "image/tiff"].includes(
            uploadFile.filetype
          )
        ) {
          // Render image
          return (
            <div style={styles.outerContainer}>
              <div key={index} style={styles.imageContainer}>
                <LazyLoadImage
                  effect="blur"
                  src={"images/" + uploadFile.filename}
                  onClick={() => openImageViewer("images/" + uploadFile.filename, index)}
                  alt={uploadFile.filename}
                  style={styles.image}
                  loading="lazy"
                />
                {/* <img
                  src={"images/" + uploadFile.filename}
                  onClick={() => openImageViewer("images/" + uploadFile.filename, index)}
                  alt={uploadFile.filename}
                  style={styles.image}
                  loading="lazy"
                /> */}
                {isViewerOpen && (
                  <ImageViewer
                    src={images}
                    currentIndex={currentImage}
                    disableScroll={false}
                    closeOnClickOutside={true}
                    onClose={closeImageViewer}
                  />
                )}
              </div>
              <MdDeleteForever
                style={styles.icon}
                onClick={() => handleClick(uploadFile.filename, index)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")} // Enlarge on hover
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")} // Reset on hover out
              />
            </div>

          );
        } else {
          // Render video or other file types
          return (
            <div key={index}>
              {playingVideo === uploadFile.filename ? (
                <video controls autoPlay>
                  <source src={"images/" + uploadFile.filename} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <VideoThumbnail
                  src={"images/" + uploadFile.filename}
                  onClick={() => handleThumbnailClick(uploadFile.filename)}
                />
              )}
              <MdDeleteForever style={styles.icon} onClick={() => handleClick(uploadFile.filename, index)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")} // Enlarge on hover
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")} // Reset on hover out
              />
              {/* <a href={"images/" + uploadFile.filename} target="_blank" rel="noopener noreferrer">
                {uploadFile.filename}
              </a> */}
            </div>
          );
        }
      })}



      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete {activeFilename}
          <br />
          {enableError ? (<p className="mt-3" style={{ color: 'red' }}>Error deleting file: {errorMessage}</p>) : (<></>)}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Delete File
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}


const styles = {
  outerContainer: {
    display: 'flex',
    flexDirection: 'column', // Stack elements vertically
    alignItems: 'center',   // Center elements horizontally
    gap: '3px',            // Add spacing between elements
    textAlign: 'center',    // Center text if needed
  },
  gallery: {
    display: "flex", // Use Flexbox
    flexWrap: "wrap", // Wrap images to the next line if they don't fit
    gap: "10px", // Space between images
  },
  imageContainer: {
    width: "100px", // Fixed width for each image container
    height: "100px",
    overflow: "hidden", // Hide overflow
    borderRadius: "8px", // Optional: Rounded corners
    border: "1px solid #ddd", // Optional: Add a border
  },
  image: {
    width: "100%", // Fill the container
    height: "100%",
    objectFit: "cover", // Ensure the image covers the container
  },
  icon: {
    fontSize: "20px", // Size of the icon
    color: "#ff0000", // Red color for the delete icon
    cursor: "pointer", // Change cursor to pointer on hover
    cursor: 'pointer', // Optional: Indicate clickability
    transition: 'transform 0.2s ease-in-out', // Smooth hover effect
  },
};
export default ImageTileComponent;